import { Route } from '@angular/router';
import { QuoteResolver } from './resolver/quote.resolver';

export const quoteRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./quote-list-page/quote-list-page.component').then(
        (c) => c.QuoteListPageComponent
      ),
  },
  {
    path: ':id',
    resolve: { quote: QuoteResolver },
    loadComponent: () =>
      import('../../quote/quote-detail-page/quote-detail-page.component').then(
        (c) => c.QuoteDetailPageComponent
      ),
  },
];
